import { Fieldset, Radio, ValidationMessage } from '@digdir/designsystemet-react';
import { FC } from 'react';
import { FieldPathByValue } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { JaNeiVetIkke } from '../../../../../../../components/registering/utils/registerEnums';
import { OppvarmingFormData } from '../../../types';
import { useOppvarmingFormContext } from '../../utils';

type JaNeiVetIkkePath = FieldPathByValue<OppvarmingFormData, JaNeiVetIkke>;

interface Props {
  name: JaNeiVetIkkePath;
}

export const ServiceSisteToArRadio: FC<Props> = ({ name }) => {
  const { t } = useTranslation();
  const { register, getFieldState } = useOppvarmingFormContext();
  const { error } = getFieldState(name);

  return (
    <Fieldset>
      <Fieldset.Legend>{t('form.oppvarming.common.kjel.service.label')}</Fieldset.Legend>
      <Radio
        {...register(name, { required: t('form.oppvarming.common.kjel.service.error'), shouldUnregister: true })}
        label={t('form.common.yes')}
        value={JaNeiVetIkke.Ja}
        aria-invalid={!!error}
      />
      <Radio
        {...register(name, { required: t('form.oppvarming.common.kjel.service.error'), shouldUnregister: true })}
        label={t('form.common.no')}
        value={JaNeiVetIkke.Nei}
        aria-invalid={!!error}
      />
      <Radio
        {...register(name, { required: t('form.oppvarming.common.kjel.service.error'), shouldUnregister: true })}
        label={t('form.common.unknown')}
        value={JaNeiVetIkke.VetIkke}
        aria-invalid={!!error}
      />
      {!!error?.message && <ValidationMessage data-color="danger">{error.message}</ValidationMessage>}
    </Fieldset>
  );
};
